import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="flex w-full items-center justify-center bg-neutral-900 px-8 py-24 text-gray-300 md:h-[700px]"
    >
      <form
        action="https://getform.io/f/jbwxqjra"
        method="POST"
        className="flex w-full max-w-[600px] flex-col"
      >
        <div className="pb-8">
          <p className="inline border-b-4 border-yellow-400 text-4xl font-semibold text-slate-300">
            Contact
          </p>
          <p className="py-4 text-slate-400">
            Let me know if you have any questions or just want to talk!
          </p>
        </div>

        <input
          className="rounded-md bg-slate-100 p-2 text-slate-900 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          type="text"
          placeholder="Your Name"
          name="name"
        />
        <input
          className="my-4 rounded-md bg-slate-100 p-2 text-slate-900 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          type="email"
          placeholder="Your Email"
          name="email"
        />
        <textarea
          className="resize-none rounded-md bg-slate-100 p-2 text-slate-900 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400"
          name="message"
          rows="5"
          placeholder="Your Message..."
        ></textarea>

        <div className="mx-auto py-8">
          <button class="btn">
            <button class="btn-texture"></button>
            <button class="btn-text">Send</button>
          </button>
        </div>
      </form>
    </div>
  );
};

export default Contact;
